import script from "./AlunosQuedas.vue?vue&type=script&setup=true&lang=js"
export * from "./AlunosQuedas.vue?vue&type=script&setup=true&lang=js"

import "./AlunosQuedas.vue?vue&type=style&index=0&id=dc41d308&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc41d308"]])

export default __exports__